import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import HiddenJs from './HiddenJs';
import HiddenCss from './HiddenCss';
/**
 * Responsively hides children based on the selected implementation.
 */

function Hidden(props) {
  var _props$implementation = props.implementation,
    implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
    _props$lgDown = props.lgDown,
    lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
    _props$lgUp = props.lgUp,
    lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
    _props$mdDown = props.mdDown,
    mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
    _props$mdUp = props.mdUp,
    mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
    _props$smDown = props.smDown,
    smDown = _props$smDown === void 0 ? false : _props$smDown,
    _props$smUp = props.smUp,
    smUp = _props$smUp === void 0 ? false : _props$smUp,
    _props$xlDown = props.xlDown,
    xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
    _props$xlUp = props.xlUp,
    xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
    _props$xsDown = props.xsDown,
    xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
    _props$xsUp = props.xsUp,
    xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
    other = _objectWithoutProperties(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
  if (implementation === 'js') {
    return /*#__PURE__*/React.createElement(HiddenJs, _extends({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }
  return /*#__PURE__*/React.createElement(HiddenCss, _extends({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Hidden;